import React, { useContext, useEffect, createContext } from "react";

// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import {
    CREATE_ORDERS_BEGIN,
    CREATE_ORDERS_SUCCESS,
    CREATE_ORDERS_FAILURE,
    GET_ORDERS_BEGIN,
    GET_ORDERS_SUCCESS,
    GET_ORDERS_FAILURE,
    DOWNLOAD_EBOOK_BEGIN,
    DOWNLOAD_EBOOK_SUCCESS,
    DOWNLOAD_EBOOK_FAILURE,
    CLOSE_PAYMENT_SUCCESS_MODAL,
    GET_ALL_ORDERS_BEGIN,
    GET_ALL_ORDERS_SUCCESS,
    GET_ALL_ORDERS_FAILURE,
    UPDATE_DOWNLOADS_ON_ENTITY_SUCCESS
} from "../constants/actions";
import { getAllOrders, getOrders, postDownloadEbook, postOrders } from "./salesforce_api_context";
import { useBugContext } from "./bug_context";

// third-party
import { useDispatch, useSelector } from "react-redux";

// Reading environment variable start
const RAZORPAY_FUNCTION_URL = process.env.REACT_APP_FIREBASE_RAZORPAY_FUNCTION_URL;
// Reading environment variable end

// Create context
export const OrderContext = createContext();

export const OrderProvider = (props) => {

    // Reading store data
    const state = useSelector((state) => state.orders);

    // Reading user store
    const userState = useSelector(item => item.user);

    const { bugReportApi } = useBugContext();

    // Reading dispatch from Store
    const dispatch = useDispatch();

    // Constant functions
    // Function to get testimonials

    const fetchAllOrders = async () => {

        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_ALL_ORDERS_BEGIN, payload: true });

            // Calling API to get testimonials 
            // let response = ordersData || [];
            let response = await getAllOrders();

            // Dispatching the actions on success
            dispatch({ type: GET_ALL_ORDERS_SUCCESS, payload: response });
        } catch (error) {
            console.log("48 : order_context : Error while getting order data::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_ALL_ORDERS_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching all orders", `/services/apexrest/order?collectionId=orders`, "GET", error);

            // Showing the toast message on getting order data unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the orders data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    const fetchOrders = async (id) => {

        try {
            // Dispatching the action to begin the api calling process
            dispatch({ type: GET_ORDERS_BEGIN, payload: true });

            // Calling API to get testimonials 
            // let response = ordersData || [];
            let response = await getOrders(id);

            // Dispatching the actions on success
            dispatch({ type: GET_ORDERS_SUCCESS, payload: response });
        } catch (error) {
            console.log("48 : order_context : Error while getting order data::", error && JSON.stringify(error));

            // Dispatching the actions on error
            dispatch({ type: GET_ORDERS_FAILURE, payload: error && error.message });

            bugReportApi("Error while fetching orders", `/services/apexrest/order/v1/search`, "GET", error);

            // Showing the toast message on getting order data unsuccessfully
            showToast("error", (error && error.message) ? "We are unable to get the orders data!" : "An error occurred", true, "bottom-right", false, true, 5000);
        }
    };

    // Function to post(add) order
    const createOrders = async (data) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: CREATE_ORDERS_BEGIN, payload: true });

            // Calling API to post order
            let response = await postOrders(data);

            // Dispatching the actions on success
            if (response?.newLsaOrder?.statusText === "Successfull") {
                const newOrder = (response?.newLsaOrder?.success || []).length > 0 ? (response?.newLsaOrder?.success || [])[0] : {};
                dispatch({ type: CREATE_ORDERS_SUCCESS, payload: response });
                return newOrder;
            }
            if (response?.newLsaOrder?.statusText === "Failed") {
                dispatch({ type: CREATE_ORDERS_FAILURE, payload: response?.newLsaOrder?.failures?.errors[0]?.message });
                showToast("error", (response?.newLsaOrder?.failures?.errors[0]?.message) ? response?.newLsaOrder?.failures?.errors[0]?.message : "We are unable to creating your order at this moment. Please try again later!", true, "bottom-right", false, true, 5000);
                return "error";
            }

            // Showing the toast message on submit order successfully
            // showToast("success", "Your order is submitted Successfully", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("84 : order_context : Error while creating order::", error && JSON.stringify(error));
            const response = error?.response;
            // Dispatching the actions on error
            dispatch({ type: CREATE_ORDERS_FAILURE, payload: response && response?.data?.error, });

            bugReportApi("Error while creating an order", `${RAZORPAY_FUNCTION_URL}`, "POST", error);

            // Showing the toast message on submitting order unsuccessfully
            showToast("error", (response && response?.data?.error) ? response && response?.data?.error : "We are unable to creating your order at this moment. Please try again later!", true, "bottom-right", false, true, 5000);

            return "error";
        }
    };

    // Function to download eBook
    const downloadEbook = async (data) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: DOWNLOAD_EBOOK_BEGIN, payload: true });
            // Calling API to download PDF
            let response = await postDownloadEbook(data);

            // Dispatching the actions on success
            if (response === "success") {
                dispatch({ type: DOWNLOAD_EBOOK_SUCCESS, payload: { response: "success", orderType: data?.entityType } });
                dispatch({ type: UPDATE_DOWNLOADS_ON_ENTITY_SUCCESS, payload: data });
                return "success";
            }
            if (response !== "success") {
                const text = response;
                dispatch({ type: DOWNLOAD_EBOOK_FAILURE, payload: text });
                showToast("error", text ? text : "We are unable to download your eBook at this moment. But don't worrry, after verifying your payment we will email the eBook to you.", true, "bottom-right", false, true, 5000);
                return "error";
            }

            // Showing the toast message on submit order successfully
            // showToast("success", "Your order is submitted Successfully", true, "bottom-right", false, true, 5000);
        } catch (error) {
            console.log("124 : order_context : Error while downloading the eBook::", error);
            const response = error?.response;
            // Dispatching the actions on error
            dispatch({ type: DOWNLOAD_EBOOK_FAILURE, payload: response && response?.data?.error, });

            bugReportApi("Error while downloading an e-book.", `${RAZORPAY_FUNCTION_URL}`, "POST", error);

            // Showing the toast message on submitting order unsuccessfully
            showToast("error", (response && response?.data?.error) ? response && response?.data?.error : "We are unable to download your eBook at this moment. But don't worrry, after verifying your payment we will email the eBook to you.", true, "bottom-right", false, true, 5000);

            return "error";
        }
    };

    // Function to close payment success
    const closePaymentSuccessModal = async (data) => {

        try {
            // Dispatching the action to begin  the api calling process
            dispatch({ type: CLOSE_PAYMENT_SUCCESS_MODAL, payload: false });

        } catch (error) {
            console.log("144 : order_context : Error while closing the payment success modal ::", error && JSON.stringify(error));
            dispatch({ type: CLOSE_PAYMENT_SUCCESS_MODAL, payload: false });
            return "error";
        }
    };

    useEffect(() => {
        // fetchAllOrders();

        const member =
            userState?.loginData && userState?.loginData?.data && userState?.loginData?.data?.userId
                ? userState?.loginData?.data
                : {};

        const userUniqueId = member && ((member?.firebaseUid ? member?.firebaseUid : member?.userRecordId));

        if (userUniqueId) {
            fetchOrders(userUniqueId);
        }
    }, []);

    return (
        <OrderContext.Provider
            value={{ ...state, fetchAllOrders, fetchOrders, createOrders, downloadEbook, closePaymentSuccessModal }}
        >
            {props.children}
        </OrderContext.Provider>
    );
};
export const useOrderContext = () => {
    return useContext(OrderContext);
};
